"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var className = function className(withTopPadding) {
  return (0, _classnames.default)('Main', {
    'Main--with-top-padding': withTopPadding
  });
};

var Main = function Main(_ref) {
  var children = _ref.children,
      withTopPadding = _ref.withTopPadding;
  return _react.default.createElement("div", {
    className: className(withTopPadding)
  }, _react.default.createElement("div", {
    className: "Main__content"
  }, children));
};

var _default = Main;
exports.default = _default;